export default __webpack_public_path__ + "static/media/clock-icon.c552af1d.svg";